import { handleVersionMismatch } from 'actions/versionSync';

import {
  CHOOSE_NEW_MANTELPIECE_FAILURE,
  CHOOSE_NEW_MANTELPIECE_REQUESTED,
  CHOOSE_NEW_MANTELPIECE_SUCCESS,
} from 'actiontypes/myself';
import { VersionMismatch } from 'services/BaseService';
import MyselfService from 'services/MyselfService';
import { IQuality } from 'types/qualities';

const chooseNewMantelpieceRequested = () => ({
  type: CHOOSE_NEW_MANTELPIECE_REQUESTED,
  isSuccess: false,
});

const chooseNewMantelpieceSuccess = (data: IQuality) => ({
  type: CHOOSE_NEW_MANTELPIECE_SUCCESS,
  isSuccess: true,
  payload: data,
});

const chooseNewMantelpieceFailure = (error: any) => ({
  type: CHOOSE_NEW_MANTELPIECE_FAILURE,
  status: error.response && error.response.status,
});


/** ----------------------------------------------------------------------------
 * Choose new Mantelpiece
 -----------------------------------------------------------------------------*/

const service = new MyselfService();

export default function chooseNewMantelpiece(item: IQuality) {
  return async (dispatch: Function) => {
    dispatch(chooseNewMantelpieceRequested());

    try {
      const { data } = await service.chooseNewMantelpiece(item);
      dispatch(chooseNewMantelpieceSuccess(data));
    } catch (error) {
      if (error instanceof VersionMismatch) {
        dispatch(handleVersionMismatch(error));
        return;
      }
      dispatch(chooseNewMantelpieceFailure(error));
    }
  };
}
